<div class="tabs tabs-lift bg-white rounded-lg">
	<label class="tab !bg-white !border-gray-200">
		<input type="radio" checked="checked" name="my_tabs_4" />
		Comorbidités
	</label>
	<div class="tab-content py-6">
		@if (medicalRecordLoading) {
		<div class="mt-4 flex justify-center py-8">
			<span class="loading loading-spinner loading-lg text-primary"></span>
		</div>
		} @else {
		<div class="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
			@for (condition of comorbidities; track condition.code) {
			<div class="rounded-2xl border border-primary/25 bg-white p-4 space-y-3">
				<div class="flex items-center justify-between gap-3">
					<span class="min-w-0 line-clamp-2 text-lg font-semibold leading-6 text-gray-900">{{ condition.label
						}}</span>
					@if (condition._id) {
					<button type="button"
						class="btn btn-xs btn-outline rounded-full! text-primary border-primary/25! border! text-xs! font-medium! bg-white py-2! px-2! h-8!  "
						(click)="openComorbidityHistory(condition)" title="Voir l'historique">
						VOIR L'HISTORIQUE
					</button>
					}
				</div>
				<div class="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white p-1">
					<label class="flex items-center gap-1.5 cursor-pointer">
						<input type="radio" [name]="'comorbidity-' + condition.code"
							[checked]="isComorbidityOui(condition)"
							(change)="onComorbidityRadioChange('oui', condition)" class="sr-only peer" />
						<span
							class="px-2 py-1 rounded text-xs font-semibold uppercase tracking-wide border border-transparent peer-checked:bg-primary peer-checked:text-white">Oui</span>
					</label>
					<label class="flex items-center gap-1.5 cursor-pointer">
						<input type="radio" [name]="'comorbidity-' + condition.code"
							[checked]="isComorbidityNon(condition)"
							(change)="onComorbidityRadioChange('non', condition)" class="sr-only peer" />
						<span
							class="px-2 py-1 rounded text-xs font-semibold uppercase tracking-wide border border-transparent peer-checked:bg-primary peer-checked:text-white">Non</span>
					</label>
					<label class="flex items-center gap-1.5 cursor-pointer">
						<input type="radio" [name]="'comorbidity-' + condition.code"
							[checked]="isComorbidityNonFait(condition)"
							(change)="onComorbidityRadioChange('non_fait', condition)" class="sr-only peer" />
						<span
							class="px-2 py-1 rounded text-xs font-semibold uppercase tracking-wide border border-transparent peer-checked:bg-primary peer-checked:text-white">Non
							fait</span>
					</label>
				</div>
				<input type="text"
					class="input w-full border-2 border-slate-200 focus:border-primary disabled:bg-slate-100 disabled:text-slate-400 disabled:cursor-not-allowed"
					placeholder="Précisez la pathologie..."
					[ngModel]="getConditionTextForInput(condition, 'comorbidity')"
					(ngModelChange)="onConditionTextInput($event, condition, 'comorbidity')"
					[disabled]="!isComorbidityOui(condition)" />
			</div>
			}
		</div>
		}
		<div class="w-full mt-10 pt-7 border-t border-gray-100 text-right">
			<button type="button" class="btn btn-primary btn-sm !text-sm"
				[disabled]="savePendingLoading || (pendingCreations.length === 0 && pendingDeactivations.length === 0)"
				(click)="savePendingChanges()">
				@if (savePendingLoading) {
				<span class="loading loading-spinner loading-xs"></span>
				}
				Sauvegarder
			</button>
		</div>
	</div>

	<label class="tab !bg-white !border-gray-200">
		<input type="radio" name="my_tabs_4" />
		Antécédents
	</label>
	<div class="tab-content p-6 space-y-5">
		<div>
			<h5 class="!text-sm text-primary">
				PERSONNELS
			</h5>
			@if (medicalRecordLoading) {
			<div class="mt-4 flex justify-center py-8">
				<span class="loading loading-spinner loading-lg text-primary"></span>
			</div>
			} @else {
			<div class="my-4 grid grid-cols-1 md:grid-cols-2 gap-4">
				@for (condition of precedents; track condition.code) {
				<div class="rounded-2xl border border-primary/25 bg-white p-4 space-y-3">
					<div class="flex items-center justify-between gap-3">
						<span class="min-w-0 line-clamp-2 text-lg font-semibold leading-6 text-gray-900">{{
							condition.label
							}}</span>
						@if (condition._id) {
						<button type="button"
							class="btn btn-xs btn-outline rounded-full! text-primary border-primary/25! border! text-xs! font-medium! bg-white py-2! px-2! h-8!  "
							(click)="openComorbidityHistory(condition)" title="Voir l'historique">
							VOIR L'HISTORIQUE
						</button>
						}
					</div>
					<div class="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white p-1">
						<label class="flex items-center gap-1.5 cursor-pointer">
							<input type="radio" [name]="'antecedent-' + condition.code"
								[checked]="isAntecedentOui(condition)"
								(change)="onAntecedentRadioChange('oui', condition)" class="sr-only peer" />
							<span
								class="px-2 py-1 rounded text-xs font-semibold uppercase tracking-wide border border-transparent peer-checked:bg-primary peer-checked:text-white">Oui</span>
						</label>
						<label class="flex items-center gap-1.5 cursor-pointer">
							<input type="radio" [name]="'antecedent-' + condition.code"
								[checked]="isAntecedentNon(condition)"
								(change)="onAntecedentRadioChange('non', condition)" class="sr-only peer" />
							<span
								class="px-2 py-1 rounded text-xs font-semibold uppercase tracking-wide border border-transparent peer-checked:bg-primary peer-checked:text-white">Non</span>
						</label>
						<label class="flex items-center gap-1.5 cursor-pointer">
							<input type="radio" [name]="'antecedent-' + condition.code"
								[checked]="isAntecedentNonFait(condition)"
								(change)="onAntecedentRadioChange('non_fait', condition)" class="sr-only peer" />
							<span
								class="px-2 py-1 rounded text-xs font-semibold uppercase tracking-wide border border-transparent peer-checked:bg-primary peer-checked:text-white">Non
								fait</span>
						</label>
					</div>
					<input type="text"
						class="input w-full border-2 border-slate-200 focus:border-primary disabled:bg-slate-100 disabled:text-slate-400 disabled:cursor-not-allowed"
						placeholder="Précisez la pathologie..."
						[ngModel]="getConditionTextForInput(condition, 'precedent')"
						(ngModelChange)="onConditionTextInput($event, condition, 'precedent')"
						[disabled]="!isAntecedentOui(condition)" />
				</div>
				}
			</div>
			}
		</div>

		<div>
			<h5 class="!text-sm text-primary !mt-7">
				Mode et Habitudes de Vie:
			</h5>

			<div class="mt-4 grid grid-cols-1 md:grid-cols-1 gap-4">
				@for (item of habits; track item.code || item.label) {
				<div class="rounded-2xl border border-primary/25 bg-white p-4 space-y-3">
					<div class="flex items-center justify-between gap-3">
						<span class="min-w-0 line-clamp-2 text-lg font-semibold leading-6 text-gray-900">{{ item.label }}</span>
						@if (item.code) {
						<button type="button"
							class="btn btn-xs btn-outline rounded-full! text-primary border-primary/25! border! text-xs! font-medium! bg-white py-2! px-2! h-8!"
							(click)="openHabitHistory(item)" title="Voir l'historique">
							VOIR L'HISTORIQUE
						</button>
						}
					</div>

					@if (item.code === 'fumeur' || item.code === 'alcool') {
					<div class="grid grid-cols-1 md:grid-cols-2 gap-3">
						<div class="rounded-xl border border-slate-200 bg-white p-3 space-y-3">
							<div class="text-sm font-semibold text-gray-700">{{ item.label }}</div>
							<div class="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white p-1">
								<label class="flex items-center gap-1.5 cursor-pointer">
									<input type="radio" [name]="'habit-' + (item.code || item.label)" [checked]="isHabitOui(item)"
										(change)="onHabitRadioChange('oui', item)" class="sr-only peer" />
									<span
										class="px-2 py-1 rounded text-xs font-semibold uppercase tracking-wide border border-transparent peer-checked:bg-primary peer-checked:text-white">Oui</span>
								</label>
								<label class="flex items-center gap-1.5 cursor-pointer">
									<input type="radio" [name]="'habit-' + (item.code || item.label)" [checked]="isHabitNon(item)"
										(change)="onHabitRadioChange('non', item)" class="sr-only peer" />
									<span
										class="px-2 py-1 rounded text-xs font-semibold uppercase tracking-wide border border-transparent peer-checked:bg-primary peer-checked:text-white">Non</span>
								</label>
								<label class="flex items-center gap-1.5 cursor-pointer">
									<input type="radio" [name]="'habit-' + (item.code || item.label)" [checked]="isHabitNonFait(item)"
										(change)="onHabitRadioChange('non_fait', item)" class="sr-only peer" />
									<span
										class="px-2 py-1 rounded text-xs font-semibold uppercase tracking-wide border border-transparent peer-checked:bg-primary peer-checked:text-white">Non
										fait</span>
								</label>
							</div>
							<input type="text" class="input w-full border-2 border-slate-200 focus:border-primary"
								placeholder="Commentaire {{ item.label }}..." [ngModel]="getHabitPrimaryComment(item)"
								(ngModelChange)="onHabitPrimaryCommentChange($event, item)" [disabled]="!isHabitOui(item)" />
						</div>

						<div class="rounded-xl border border-slate-200 bg-slate-50 p-3 space-y-3">
							<div class="text-sm font-semibold text-gray-700">Sevrage</div>
							<div class="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white p-1">
								<label class="flex items-center gap-1.5 cursor-pointer">
									<input type="radio" [name]="'sevrage-' + (item.code || item.label)" class="sr-only peer"
										[checked]="getHabitSevrageValue(item) === 'oui'"
										(change)="onHabitSevrageChange('oui', item)" />
									<span
										class="px-2 py-1 rounded text-xs font-semibold uppercase tracking-wide border border-transparent peer-checked:bg-primary peer-checked:text-white">Oui</span>
								</label>
								<label class="flex items-center gap-1.5 cursor-pointer">
									<input type="radio" [name]="'sevrage-' + (item.code || item.label)" class="sr-only peer"
										[checked]="getHabitSevrageValue(item) === 'non'"
										(change)="onHabitSevrageChange('non', item)" />
									<span
										class="px-2 py-1 rounded text-xs font-semibold uppercase tracking-wide border border-transparent peer-checked:bg-primary peer-checked:text-white">Non</span>
								</label>
								<label class="flex items-center gap-1.5 cursor-pointer">
									<input type="radio" [name]="'sevrage-' + (item.code || item.label)" class="sr-only peer"
										[checked]="getHabitSevrageValue(item) === 'non_fait'"
										(change)="onHabitSevrageChange('non_fait', item)" />
									<span
										class="px-2 py-1 rounded text-xs font-semibold uppercase tracking-wide border border-transparent peer-checked:bg-primary peer-checked:text-white">Non
										fait</span>
								</label>
							</div>
							<input type="text" class="input w-full border-2 border-slate-200 focus:border-primary"
								placeholder="Commentaire sevrage..." [ngModel]="getHabitSevrageComment(item)"
								(ngModelChange)="onHabitSevrageCommentChange($event, item)"
								[disabled]="getHabitSevrageValue(item) !== 'oui'" />
						</div>
					</div>
					} @else if (item.code === 'pratique-sport') {
					<textarea
						class="textarea !text-gray-600 !border-gray-300 w-full h-20 !bg-white focus:outline-none focus:ring-1 focus:ring-primary"
						placeholder="Décrivez la pratique sportive..." [ngModel]="getSportText()"
						(ngModelChange)="onSportTextChange($event)"></textarea>
					} @else if (item.code === 'habitudes-sexuelles') {
					<textarea
						class="textarea !text-gray-600 !border-gray-300 w-full h-20 !bg-white focus:outline-none focus:ring-1 focus:ring-primary"
						placeholder="Décrivez les habitudes sexuelles..." [ngModel]="getSexualHabitsText()"
						(ngModelChange)="onSexualHabitsTextChange($event)"></textarea>
					} @else {
					<div class="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white p-1">
						<label class="flex items-center gap-1.5 cursor-pointer">
							<input type="radio" [name]="'habit-' + (item.code || item.label)" [checked]="isHabitOui(item)"
								(change)="onHabitRadioChange('oui', item)" class="sr-only peer" />
							<span
								class="px-2 py-1 rounded text-xs font-semibold uppercase tracking-wide border border-transparent peer-checked:bg-primary peer-checked:text-white">Oui</span>
						</label>
						<label class="flex items-center gap-1.5 cursor-pointer">
							<input type="radio" [name]="'habit-' + (item.code || item.label)" [checked]="isHabitNon(item)"
								(change)="onHabitRadioChange('non', item)" class="sr-only peer" />
							<span
								class="px-2 py-1 rounded text-xs font-semibold uppercase tracking-wide border border-transparent peer-checked:bg-primary peer-checked:text-white">Non</span>
						</label>
						<label class="flex items-center gap-1.5 cursor-pointer">
							<input type="radio" [name]="'habit-' + (item.code || item.label)" [checked]="isHabitNonFait(item)"
								(change)="onHabitRadioChange('non_fait', item)" class="sr-only peer" />
							<span
								class="px-2 py-1 rounded text-xs font-semibold uppercase tracking-wide border border-transparent peer-checked:bg-primary peer-checked:text-white">Non
								fait</span>
						</label>
					</div>
					}

				</div>
				}
			</div>
		</div>

		<div>
			<h5 class="!text-sm text-primary !mt-7">
				GYNÉCO-OBSTÉTRICAUX
			</h5>
			<div class="mt-2 text-right">
				<button type="button"
					class="btn btn-xs btn-outline rounded-full! text-primary border-primary/25! border! text-xs! font-medium! bg-white py-2! px-2! h-8!"
					(click)="openGynecoHistory()" title="Voir l'historique">
					VOIR L'HISTORIQUE
				</button>
			</div>

			<div class="mt-4 space-y-4">
				<!-- Première ligne d'inputs -->
				<div class="grid grid-cols-1 md:grid-cols-3 gap-4">
					<div>
						<label class="text-sm text-gray-700 mb-2 block">Ménarche <span
								class="text-xs text-gray-400">(années)</span></label>
						<input type="number" class="input !border-gray-300 placeholder:!text-gray-400 w-full"
							placeholder="Ex: 13" [(ngModel)]="gynecologicalHistory.menarcheAge"
							(ngModelChange)="onGynecoChange()" />
					</div>
					<div>
						<label class="text-sm text-gray-700 mb-2 block">Cycle <span
								class="text-xs text-gray-400">(jours)</span></label>
						<input type="number" class="input !border-gray-300 placeholder:!text-gray-400 w-full"
							placeholder="Ex: 28" [(ngModel)]="gynecologicalHistory.cycleDuration"
							(ngModelChange)="onGynecoChange()" />
					</div>
					<div>
						<label class="text-sm text-gray-700 mb-2 block">Gestité</label>
						<input type="number" class="input !border-gray-300 placeholder:!text-gray-400 w-full"
							placeholder="Ex: 2" [(ngModel)]="gynecologicalHistory.gestite"
							(ngModelChange)="onGynecoChange()" />
					</div>
				</div>

				<!-- Deuxième ligne d'inputs -->
				<div class="grid grid-cols-1 md:grid-cols-3 gap-4">
					<div>
						<label class="text-sm text-gray-700 mb-2 block">Parité</label>
						<input type="number" class="input !border-gray-300 placeholder:!text-gray-400 w-full"
							placeholder="Ex: 1" [(ngModel)]="gynecologicalHistory.parite"
							(ngModelChange)="onGynecoChange()" />
					</div>
					<div>
						<label class="text-sm text-gray-700 mb-2 block">Issue des grossesses</label>
						<input type="text" class="input !border-gray-300 placeholder:!text-gray-400 w-full"
							placeholder="Ex: 1 accouchement normal" [(ngModel)]="gynecoIssueString"
							(ngModelChange)="onGynecoChange()" />
					</div>
					<div>
						<label class="text-sm text-gray-700 mb-2 block">Enfants vivants</label>
						<input type="number" class="input !border-gray-300 placeholder:!text-gray-400 w-full"
							placeholder="Ex: 1" [(ngModel)]="gynecologicalHistory.livingChildrenCount"
							(ngModelChange)="onGynecoChange()" />
					</div>
				</div>

				<div>
					<label class="text-sm text-gray-700 mb-2 block">Observations</label>
					<textarea
						class="textarea !text-gray-600 !border-gray-300 w-full h-24 !bg-white focus:outline-none focus:ring-1 focus:ring-primary"
						placeholder="Ex: Antécédents obstétricaux particuliers"
						[(ngModel)]="gynecologicalHistory.notes" (ngModelChange)="onGynecoChange()"></textarea>
				</div>

				<div class="grid grid-cols-1 md:grid-cols-2 gap-4">
					<div class="rounded-2xl border border-primary/25 bg-white p-4 space-y-3">
						<div class="flex items-center justify-between gap-3">
							<span class="text-lg font-semibold leading-6 text-gray-900">Contraception</span>
							<button type="button"
								class="btn btn-xs btn-outline rounded-full! text-primary border-primary/25! border! text-xs! font-medium! bg-white py-2! px-2! h-8!"
								(click)="openGynecoHistory()" title="Voir l'historique">
								VOIR L'HISTORIQUE
							</button>
						</div>
						<div class="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white p-1">
							<label class="flex items-center gap-1.5 cursor-pointer">
								<input type="radio" name="contraception" class="sr-only peer"
									[checked]="getGynecoRadioValue('contraception') === 'oui'"
									(change)="onGynecoRadioChange('oui', 'contraception')" />
								<span
									class="px-2 py-1 rounded text-xs font-semibold uppercase tracking-wide border border-transparent peer-checked:bg-primary peer-checked:text-white">Oui</span>
							</label>
							<label class="flex items-center gap-1.5 cursor-pointer">
								<input type="radio" name="contraception" class="sr-only peer"
									[checked]="getGynecoRadioValue('contraception') === 'non'"
									(change)="onGynecoRadioChange('non', 'contraception')" />
								<span
									class="px-2 py-1 rounded text-xs font-semibold uppercase tracking-wide border border-transparent peer-checked:bg-primary peer-checked:text-white">Non</span>
							</label>
							<label class="flex items-center gap-1.5 cursor-pointer">
								<input type="radio" name="contraception" class="sr-only peer"
									[checked]="getGynecoRadioValue('contraception') === 'non_fait'"
									(change)="onGynecoRadioChange('non_fait', 'contraception')" />
								<span
									class="px-2 py-1 rounded text-xs font-semibold uppercase tracking-wide border border-transparent peer-checked:bg-primary peer-checked:text-white">Non
									fait</span>
							</label>
						</div>
						<input type="text" class="input w-full border-2 border-slate-200 focus:border-primary"
							placeholder="Précisez le type de contraception..."
							[(ngModel)]="gynecologicalHistory.contraceptionComment" (ngModelChange)="onGynecoChange()"
							[disabled]="getGynecoRadioValue('contraception') !== 'oui'" />
					</div>
					<div class="rounded-2xl border border-primary/25 bg-white p-4 space-y-3">
						<div class="flex items-center justify-between gap-3">
							<span class="text-lg font-semibold leading-6 text-gray-900">Ménopause</span>
							<button type="button"
								class="btn btn-xs btn-outline rounded-full! text-primary border-primary/25! border! text-xs! font-medium! bg-white py-2! px-2! h-8!"
								(click)="openGynecoHistory()" title="Voir l'historique">
								VOIR L'HISTORIQUE
							</button>
						</div>
						<div class="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white p-1">
							<label class="flex items-center gap-1.5 cursor-pointer">
								<input type="radio" name="menopause" class="sr-only peer"
									[checked]="getGynecoRadioValue('menopause') === 'oui'"
									(change)="onGynecoRadioChange('oui', 'menopause')" />
								<span
									class="px-2 py-1 rounded text-xs font-semibold uppercase tracking-wide border border-transparent peer-checked:bg-primary peer-checked:text-white">Oui</span>
							</label>
							<label class="flex items-center gap-1.5 cursor-pointer">
								<input type="radio" name="menopause" class="sr-only peer"
									[checked]="getGynecoRadioValue('menopause') === 'non'"
									(change)="onGynecoRadioChange('non', 'menopause')" />
								<span
									class="px-2 py-1 rounded text-xs font-semibold uppercase tracking-wide border border-transparent peer-checked:bg-primary peer-checked:text-white">Non</span>
							</label>
							<label class="flex items-center gap-1.5 cursor-pointer">
								<input type="radio" name="menopause" class="sr-only peer"
									[checked]="getGynecoRadioValue('menopause') === 'non_fait'"
									(change)="onGynecoRadioChange('non_fait', 'menopause')" />
								<span
									class="px-2 py-1 rounded text-xs font-semibold uppercase tracking-wide border border-transparent peer-checked:bg-primary peer-checked:text-white">Non
									fait</span>
							</label>
						</div>
						<input type="text" class="input w-full border-2 border-slate-200 focus:border-primary"
							placeholder="Précisez l'âge de ménopause..." [(ngModel)]="gynecologicalHistory.menopauseComment"
							(ngModelChange)="onGynecoChange()" [disabled]="getGynecoRadioValue('menopause') !== 'oui'" />
					</div>
				</div>
			</div>
		</div>

		<div>
			<h5 class="!text-sm text-primary !mt-7">
				FAMILIAUX
			</h5>
			<div class="mt-2 text-right">
				<button type="button"
					class="btn btn-xs btn-outline rounded-full! text-primary border-primary/25! border! text-xs! font-medium! bg-white py-2! px-2! h-8!"
					(click)="openFamilyHistory()" title="Voir l'historique">
					VOIR L'HISTORIQUE
				</button>
			</div>

			<div class="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4">
				<div>
					<label class="text-sm text-gray-700 mb-2 block">Ascendants</label>
					<textarea
						class="textarea !text-gray-600 !border-gray-300 w-full h-24 !bg-white focus:outline-none focus:ring-1 focus:ring-primary"
						placeholder="Ex: Père: HTA, Mère: Diabète" [(ngModel)]="familyHistory.ascendants"
						(ngModelChange)="onFamilyChange()"></textarea>
				</div>
				<div>
					<label class="text-sm text-gray-700 mb-2 block">Fratrie</label>
					<textarea
						class="textarea !text-gray-600 !border-gray-300 w-full h-24 !bg-white focus:outline-none focus:ring-1 focus:ring-primary"
						placeholder="Ex: Frère: Asthme, Sœur: Aucun" [(ngModel)]="familyHistory.fratrie"
						(ngModelChange)="onFamilyChange()"></textarea>
				</div>
				<div>
					<label class="text-sm text-gray-700 mb-2 block">Pathologies familiales</label>
					<textarea
						class="textarea !text-gray-600 !border-gray-300 w-full h-24 !bg-white focus:outline-none focus:ring-1 focus:ring-primary"
						placeholder="Ex: HTA, Diabète, Cancer" [(ngModel)]="familyHistory.pathologies"
						(ngModelChange)="onFamilyChange()"></textarea>
				</div>
			</div>

			<div class="mt-6">
				<div class="flex items-center justify-between mb-3">
					<span class="text-sm font-medium text-gray-700">Arbre généalogique</span>
					<button type="button" class="btn btn-outline btn-sm text-primary border-primary/25"
						(click)="openFamilyMemberModal()">
						+ Ajouter un membre de famille
					</button>
				</div>

				@if (familyMembers.length > 0) {
				<div class="space-y-2">
					@for (member of familyMembers; track $index) {
					<div class="flex items-center justify-between px-4 py-2 rounded-lg border border-slate-200 bg-gray-50">
						<span class="text-sm text-gray-800">
							{{ member.firstName }} {{ member.lastName }}
							<span class="text-xs text-gray-500 ml-2">({{ member.relationship }})</span>
						</span>
						<button type="button" class="btn btn-ghost btn-xs text-red-400" (click)="removeFamilyMember($index)">
							✕
						</button>
					</div>
					}
				</div>
				} @else {
				<p class="text-sm text-gray-400 italic">Aucun membre ajouté.</p>
				}
			</div>
		</div>

		<div class="w-full mt-6 pt-5 border-t border-gray-100 text-right">
			<button type="button" class="btn btn-primary btn-sm !text-sm"
				[disabled]="savePendingLoading || (pendingCreations.length === 0 && pendingDeactivations.length === 0 && pendingHabits.length === 0 && !pendingGyneco && !pendingFamily)"
				(click)="savePendingChanges()">
				@if (savePendingLoading) {
				<span class="loading loading-spinner loading-xs"></span>
				}
				Sauvegarder
			</button>
		</div>
	</div>
</div>
